import { ISection } from "../type";
import { APP_VERSION } from "../appVersion";

const STORAGE_KEY = "ww_lessons_sections_cache_v1";

type CachedPayload = {
  userId: number;
  appVersion: string;
  storedAt: number;
  sections: ISection[];
};

function parsePayload(raw: string | null): CachedPayload | null {
  if (!raw) return null;
  try {
    const data = JSON.parse(raw) as CachedPayload;
    if (!data || typeof data.userId !== "number" || !Array.isArray(data.sections)) return null;
    return data;
  } catch {
    return null;
  }
}

/** Последний успешный ответ get_current_lessons (после нормализации в lesson.ts). */
export function readLessonsSectionsCache(userId: number): ISection[] | null {
  if (typeof window === "undefined" || !Number.isFinite(userId) || userId <= 0) return null;
  try {
    const data = parsePayload(sessionStorage.getItem(STORAGE_KEY));
    if (!data) return null;
    if (data.userId !== userId) return null;
    if (data.appVersion !== APP_VERSION) return null;
    return data.sections;
  } catch {
    return null;
  }
}

export function writeLessonsSectionsCache(userId: number, sections: ISection[]): void {
  if (typeof window === "undefined" || !Number.isFinite(userId) || userId <= 0) return;
  if (!Array.isArray(sections) || sections.length === 0) return;
  try {
    const payload: CachedPayload = {
      userId,
      appVersion: APP_VERSION,
      storedAt: Date.now(),
      sections,
    };
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  } catch {
    // квота / приватный режим — не ломаем UX
  }
}

export function clearLessonsSectionsCache(): void {
  if (typeof window === "undefined") return;
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
